<script lang="ts">
    import { Col} from "sveltestrap";
    import { SmallSizeScroll } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    let imgpath:string='../assets/images/banner'
</script>
<Col sm="6">
    <Card cardHeaderprops="pb-0" headerTitle={SmallSizeScroll}>
        <div slot="contentbody">
            <div class="scroll-bar-wrap">
                <div class="scrollbar-margins large-margin scroll-demo p-0">
                    <img src="{imgpath}/3.jpg" alt="girl" width="800" height="600" >
                </div>
            </div>
        </div>
    </Card>
</Col>

        
